var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.75 3.75H3.755M10.545 6.955L6.96 10.54C6.86713 10.633 6.75684 10.7067 6.63544 10.7571C6.51404 10.8074 6.38392 10.8333 6.2525 10.8333C6.12108 10.8333 5.99096 10.8074 5.86956 10.7571C5.74816 10.7067 5.63787 10.633 5.545 10.54L1.25 6.25V1.25H6.25L10.545 5.545C10.7313 5.73236 10.8358 5.98581 10.8358 6.25C10.8358 6.51419 10.7313 6.76764 10.545 6.955Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tag.30878bd3.svg";
export { ForwardRef as ReactComponent };